@if (externalSystemInfo()) {
  <div
    class="banner"
    [ngClass]="{
      'connected-background': connected(),
      'disconnected-background': !connected() && showDescription(),
      'child-background': !connected() && !showDescription(),
      expanded: expanded,
    }"
    s2aLayout="row"
    s2aLayoutAlign="space-between center"
    [s2aLayoutAlign.lt-md]="
      !externalSystemInfo().children?.length ? 'space-between flex-start' : 'space-between center'
    "
    [s2aLayout.lt-md]="!externalSystemInfo().children?.length ? 'column' : 'row'"
  >
    <div s2aLayout="row" s2aLayoutAlign="start center">
      @if (connected()) {
        <mat-icon class="icon connected-color">check_circle</mat-icon>
      } @else {
        <mat-icon svgIcon="states_watch_warning" class="icon disconnected-color"></mat-icon>
      }
      <div
        s2aLayout="row"
        s2aLayout.md="column"
        [s2aLayout.lt-md]="!externalSystemInfo().children?.length ? 'row' : 'column'"
        s2aLayoutAlign="start center"
        s2aLayoutAlign.md="center start"
        [s2aLayoutAlign.lt-md]="!externalSystemInfo().children?.length ? 'start center' : 'center start'"
        class="pl-8"
      >
        <p [ngClass]="{ 'connected-color': connected(), 'disconnected-color': !connected() }" class="title">
          {{ externalSystemInfo().title }}&nbsp;
        </p>
        <p [class.bold]="connected()">{{ externalSystemInfo().subTitle }}&nbsp;</p>
        @if (showDescription()) {
          <p>{{ externalSystemInfo().description }}</p>
        }
      </div>
    </div>
    @if (!connected() && !externalSystemInfo().children?.length) {
      <div class="s2a-flex s2a-fx-align-center">
        <span class="time">Time&nbsp;</span>
        <span class="time"
          >{{ externalSystemInfo().currentState.timestamp | formatEpoch: currentTimeStamp }}&nbsp;
        </span>
        <mat-chip-set class="pl-10">
          <mat-chip class="details" (click)="openContactSuppotDialogue(externalSystemInfo())">{{
            'components.external_system.contact_support' | translate
          }}</mat-chip>
        </mat-chip-set>
        <button mat-button (click)="openSystemInfoDialogue(externalSystemInfo())" class="system-info">
          <mat-icon class="mr-0">chevron_right</mat-icon>{{ 'components.external_system.details' | translate }}
        </button>
      </div>
    } @else if (!connected() && externalSystemInfo().children?.length) {
      <div>
        <mat-chip-set>
          <mat-chip class="details" (click)="toggleUI()"
            ><mat-icon class="rotate" [class.down]="expanded">chevron_right</mat-icon
            >{{
              expanded
                ? ('components.external_system.less' | translate)
                : ('components.external_system.more' | translate)
            }}
          </mat-chip>
        </mat-chip-set>
      </div>
    } @else {
      <mat-icon class="icon c-ptr" (click)="closeExternalSystemStatusBanner(externalSystemInfo())">close</mat-icon>
    }
  </div>
  @if (externalSystemInfo().children?.length) {
    <div class="panel-content-wrapper">
      <div class="panel-content s2a-flex-gap-6 s2a-fx-column">
        @for (externalSystemStatusItem of externalSystemInfo().children; track externalSystemStatusItem) {
          <s2a-banner
            [externalSystemInfo]="externalSystemStatusItem"
            [showDescription]="false"
            (showDetail)="openSystemInfoDialogue($event)"
            (openContactSupport)="openContactSuppotDialogue($event)"
            (closeBanner)="closeExternalSystemStatusBanner($event)"
          />
        }
      </div>
    </div>
  }
}
